import React, { useState } from "react";
import { MailWarning, Loader2 } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export const VerifyBanner = () => {
  const { user } = useAuth();
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  if (!user || user.email_verified) return null;

  const resend = async () => {
    setSending(true);
    try {
      const { data } = await api.post("/auth/resend-verification");
      toast.success(data.message, { description: "Can't find it? Check your spam or junk folder." });
      setSent(true);
    } catch (e) {
      toast.error(apiError(e.response?.data?.detail) || "Could not resend the email");
    } finally {
      setSending(false);
    }
  };

  return (
    <div data-testid="verify-banner" className="mb-6 flex flex-wrap items-center gap-x-3 gap-y-1.5 px-4 py-3 rounded-xl border border-amber-300 bg-amber-50 dark:bg-amber-950/30 dark:border-amber-900">
      <MailWarning className="w-4 h-4 text-amber-700 dark:text-amber-300 shrink-0" />
      <div className="flex-1 min-w-[220px]">
        <span className="text-sm text-amber-900 dark:text-amber-200 block">
          Confirm your email ({user.email}) to {user.account_type === "einvoice" ? "finish setting up your account" : "unlock sending RFQs and quotations"}.
        </span>
        <span data-testid="verify-spam-note" className="text-xs text-amber-800/80 dark:text-amber-300/70 block mt-0.5">
          Don't see it in your inbox? Please check your spam or junk folder.
        </span>
      </div>
      <button
        data-testid="resend-verification"
        onClick={resend}
        disabled={sending || sent}
        className="text-xs font-bold text-amber-900 dark:text-amber-200 underline disabled:opacity-60 inline-flex items-center gap-1.5"
      >
        {sending && <Loader2 className="w-3 h-3 animate-spin" />}
        {sent ? "Email sent" : "Resend confirmation"}
      </button>
    </div>
  );
};
